export type ResourceQuotaLevel='unknown'|'safe'|'watch'|'near'|'action'|'protection';
export interface ResourceQuotaUsage{readonly firebasePercent:number|null;readonly cloudflarePercent:number|null;}
export interface ResourceQuotaReading{readonly label:'Firebase'|'Cloudflare';readonly percent:number|null;readonly level:ResourceQuotaLevel;}

type ResourceUsageSource={firebasePercent?:unknown;cloudflarePercent?:unknown};

const normalizePercent=(value:unknown):number|null=>{
  const numberValue=typeof value==='number'?value:Number(value);
  return Number.isFinite(numberValue)?Math.max(0,Math.min(100,numberValue)):null;
};

export const resourceQuotaLevel=(percent:number|null):ResourceQuotaLevel=>{
  if(percent===null)return 'unknown';
  if(percent>=98)return 'protection';
  if(percent>=95)return 'action';
  if(percent>=85)return 'near';
  if(percent>=70)return 'watch';
  return 'safe';
};

export function readResourceQuotaUsage():ResourceQuotaUsage{
  if(typeof window==='undefined')return {firebasePercent:null,cloudflarePercent:null};
  const source=(window as unknown as {__MOREFUN_RESOURCE_USAGE__?:ResourceUsageSource}).__MOREFUN_RESOURCE_USAGE__;
  return {
    firebasePercent:normalizePercent(source?.firebasePercent),
    cloudflarePercent:normalizePercent(source?.cloudflarePercent),
  };
}

export function resourceQuotaReadings(usage=readResourceQuotaUsage()):readonly ResourceQuotaReading[]{
  return [
    {label:'Firebase',percent:usage.firebasePercent,level:resourceQuotaLevel(usage.firebasePercent)},
    {label:'Cloudflare',percent:usage.cloudflarePercent,level:resourceQuotaLevel(usage.cloudflarePercent)},
  ];
}

export const hasResourceQuotaAlert=(usage=readResourceQuotaUsage())=>resourceQuotaReadings(usage).some(reading=>reading.level!=='unknown'&&reading.level!=='safe');
export const formatResourceQuotaPercent=(percent:number|null)=>percent===null?'—%':`${Math.round(percent)}%`;
